import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export let APP_CONFIG: any = {};
export let APP_CONFIG_LOCAL: any = {};
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private appConfig: any;
  private appConfigLocal: any;

  constructor(private injector: Injector) { }

  loadAppConfig() {
    const http = this.injector.get(HttpClient);

    return firstValueFrom(http.get('./assets/config/app-config.json'))
      .then((data) => {
        this.appConfig = data;
        APP_CONFIG = Object.assign(this.appConfig);
      })
      .catch((err) => {
        console.error(err);
      })
  }

  loadLocalConfig() {
    const http = this.injector.get(HttpClient);

    return firstValueFrom(http.get('./assets/config/app-config-local.json'))
      .then((data) => {
        this.appConfigLocal = data;
        APP_CONFIG_LOCAL = Object.assign(this.appConfigLocal);
      })
      .catch((err) => {
        console.error(err);
      })
  }

}
